import {
  googlePaymentsGateway,
  googlePaymentsGatewayMerchantIdCA,
  googlePaymentsGatewayMerchantIdUS,
  googlePrepaidPaymentsGateway,
  googlePrepaidPaymentsGatewayMerchantIdCA,
  googlePrepaidPaymentsGatewayMerchantIdUS
} from 'utils/environment';
import { PaymentISOs } from 'utils/form/constants';

export enum TransactionType {
  PAYMENT = 'payment',
  PREPAID = 'prepaid'
}

interface IgetGooglePaymentsConfigs {
  transactionType: TransactionType;
  countryCode: PaymentISOs;
}

/**
 * This function return the Google Pay transaction configs based on the transaction type and countrycode
 * It is returning the gateway and the gateway merchant id
 */
export const getGooglePaymentsConfigs = ({
  transactionType,
  countryCode
}: IgetGooglePaymentsConfigs) => {
  // Checking if it's a prepaid or a payment transaction
  const isPayment = transactionType === TransactionType.PAYMENT;

  // Getting the right gateway based on the transaction type
  const gateway = isPayment ? googlePaymentsGateway : googlePrepaidPaymentsGateway;

  // Getting the gateway merchant id based on the transaction type and the country code of the transaction
  let gatewayMerchantId;
  switch (countryCode) {
    case PaymentISOs.CA:
      gatewayMerchantId = isPayment
        ? googlePaymentsGatewayMerchantIdCA
        : googlePrepaidPaymentsGatewayMerchantIdCA;
      break;
    case PaymentISOs.CH:
    case PaymentISOs.GB:
    case PaymentISOs.US:
      gatewayMerchantId = isPayment
        ? googlePaymentsGatewayMerchantIdUS
        : googlePrepaidPaymentsGatewayMerchantIdUS;
      break;
    default:
      gatewayMerchantId = '';
  }
  // Returning the right conf
  return { gateway, gatewayMerchantId };
};
